import { isCNDomain } from "@/helpers/utils";

export const qaUrl = isCNDomain()
  ? "https://nubisuemcloud.zohodesk.com/portal/zh/kb"
  : "https://nubisuemcloud.zohodesk.com/portal/en/home";
